module.exports = __webpack_public_path__ + "static/marcote-onai-logo-d41116bf5a33f7518fa4aa849228f4b1.svg";